export type CsvValue = string | number
export type CsvRow = Record<string, CsvValue>

export const toCsvValue = (value: unknown): CsvValue => {
    if (value === undefined || value === null) {
        return ''
    }

    if (typeof value === 'string' || typeof value === 'number') {
        return value
    }

    if (typeof value === 'object') {
        const aggregate = value as {sum?: unknown, count?: unknown}

        if (typeof aggregate.sum === 'number' || typeof aggregate.sum === 'string') {
            return aggregate.sum
        }

        if (typeof aggregate.count === 'number' || typeof aggregate.count === 'string') {
            return aggregate.count
        }
    }

    return String(value)
}
